import React, { PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

export default class DialogImage extends React.Component {

  static propTypes = {
    openModal: PropTypes.bool.isRequired
  };

  state = {
    open: false
  };

  render() {
    let { children, openModal, onRequestClose } = this.props;

    const actions = [
      <FlatButton
        label="Ok"
        primary={true}
        keyboardFocused={true}
        onClick={onRequestClose}
      />
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={false}
          open={openModal}
          onRequestClose={onRequestClose}
        >
          {children}
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/form/DialogImage.jsx